import type { ReactNode } from 'react';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl-next';

import { xcss, Flex, Box, Inline } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import AtlassianIntelligenceIcon from '@atlaskit/icon/core/atlassian-intelligence';
import Popup from '@atlaskit/popup';
import type { TriggerProps } from '@atlaskit/popup';

import { mockData } from '../mockData';
import { messages } from '../messages';

const popupContentStyles = xcss({
	paddingBlock: 'space.075',
	paddingInline: 'space.150',
	width: '204px',
	whiteSpace: 'pre-wrap',
});

const popupFooterStyles = xcss({
	paddingBlock: 'space.100',
	paddingInline: 'space.150',
	color: 'color.text.subtlest',
	font: token('font.body.small'),
});

type PopupTriggerRenderFn = (props: {
	isOpen: boolean;
	togglePopup: () => void;
	triggerProps: TriggerProps;
}) => ReactNode;

type LoomScriptInfoPopupProps = {
	trigger: PopupTriggerRenderFn;
};

export const LoomScriptInfoPopup = ({ trigger }: LoomScriptInfoPopupProps) => {
	const [isOpen, setIsOpen] = useState(false);
	const togglePopup = () => setIsOpen((prev) => !prev);

	return (
		<Popup
			shouldRenderToParent
			isOpen={isOpen}
			onClose={() => setIsOpen(false)}
			placement="bottom-start"
			content={() => (
				<Box>
					<Inline xcss={popupContentStyles}>{mockData.loomScriptJustification}</Inline>
					<Flex xcss={popupFooterStyles} alignItems="center" gap="space.050">
						<FormattedMessage {...messages.aiBadgeText} />
						<AtlassianIntelligenceIcon label="AI icon" />
					</Flex>
				</Box>
			)}
			trigger={(triggerProps) => trigger({ isOpen, togglePopup, triggerProps })}
		/>
	);
};
